import { z } from "zod";
/** Wire shape of a card. Mirrors the engine's card on purpose: the protocol owns its own types. */
export const suitSchema = z.enum(["spades", "hearts", "diamonds", "clubs"]);
export const rankSchema = z.number().int().min(2).max(14);
export const cardSchema = z.object({ suit: suitSchema, rank: rankSchema });
//# sourceMappingURL=cards.js.map